var getOverarchingAwareSectionDataField, isOverarchingTemplate;

isOverarchingTemplate = require('stores/utils/etd_template_helper').isOverarchingTemplate;

getOverarchingAwareSectionDataField = function(sectionData, fieldName, ratingFieldName, templateName, notSetValue) {
  var ratingValue;
  if (isOverarchingTemplate(templateName)) {
    ratingValue = sectionData != null ? sectionData.get(ratingFieldName) : void 0;
    if (!_.isEmpty(ratingValue)) {
      return ratingValue;
    }
  }
  return sectionData != null ? sectionData.get(fieldName, notSetValue) : void 0;
};

module.exports = {
  getOverarchingAwareSectionDataField: getOverarchingAwareSectionDataField
};
